
export class TaskCommentsRequestModel {

  constructor(
    public taskId: string,
    public since?: number,
  ) { }

}
